/**
 * Labstep
 *
 * @module components/Organization/Form/ShowEdit/Name
 * @desc Name showedit field
 */

import { fieldOrganizationName } from 'labstep-web/components/Organization/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { OrganizationFormShowEditNameProps } from './types';

export const OrganizationFormShowEditName: React.FC<
  OrganizationFormShowEditNameProps
> = ({ organization }) => (
  <ShowEditText
    entityName={organization.entityName}
    entity={organization}
    field={fieldOrganizationName}
  >
    {organization.name}
  </ShowEditText>
);
